import { createStore } from 'vuex'
import auth from './auth'
import user from './user'
import paths from './paths'
import loader from './loader'
import outputs from './outputs'
import account from './account'
import payment from './payment'
import quizzes from './quizzes'
import content from './content'
import starlink from './starlink'
import staticAws from './staticAws'
import marketplace from './marketplace'
import firstAccess from './firstAccess'
import suitability from './suitability'
import notification from './notification'
import informationToast from './informationToast'
import createPersistedState from 'vuex-persistedstate'
import profession from './b2b/profession'

const store = createStore({
  modules: {
    auth,
    user,
    paths,
    loader,
    outputs,
    account,
    quizzes,
    payment,
    content,
    starlink,
    staticAws,
    marketplace,
    firstAccess,
    suitability,
    notification,
    informationToast,
    profession,
  },
  plugins: [createPersistedState({ key: '__stg' })]
})

export default store
